import React from 'react';
import '../styles/MaintenancePage.css';

export default function MaintenancePage() {
  return (
    <div className="maintenance-wrapper">
      <div className="maintenance-content">
        <h1>We're Under Maintenance</h1>
        <p>The online store is temporarily unavailable. Please check back soon!</p>
      </div>
    </div>
  );
}
